import { DeliveryType } from '@libs/core';

import { useAutoshipDecisions } from './useAutoshipDecisions';
import { useCart } from './useCart';

/**
 * Hook to check if SDD + Autoship scenario should show shipping address section and banner
 */
export function useIsSddWithAutoship() {
    const { cart } = useCart();
    const { isAutoshipCrawl } = useAutoshipDecisions();

    const hasSddWithAutoship = cart?.fulfillmentGroups?.some(
        group =>
            group.fulfillmentMethod.toLowerCase() === DeliveryType.SDD &&
            group.items?.some(item => item.autoshipFrequency && item.autoshipFrequencyUnitOfMeasure)
    );

    return isAutoshipCrawl && hasSddWithAutoship;
}
